import React, { Component } from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import classNames from "classnames";

class SearchBar extends Component {
  handleOnChange() {
    return event => {
      if (!this.props.handleNewSearchValue) {
        return;
      }

      const newValue = event.target.value;
      this.props.handleNewSearchValue(newValue);
    };
  }

  render() {
    const { className, placeholder, value } = this.props;

    return (
      <div className={className}>
        <div className={classNames("search-container", value && "active")}>
          <input
            className="step-search-input"
            value={value || ""}
            placeholder={placeholder || ""}
            onChange={this.handleOnChange()}
          />
          <label htmlFor="step-search-input">
            <i className="fas fa-search" />
          </label>
        </div>
      </div>
    );
  }
}

SearchBar.propTypes = {
  value: PropTypes.string,
  placeholder: PropTypes.string,
  handleNewSearchValue: PropTypes.func
};

export default styled(SearchBar)`
  color: ${props => props.theme["$gray-50"]};
  font-size: 14px;

  .search-container {
    display: flex;
    justify-content: space-between;
    width: 190px;
    position: relative; /* Anchor to me */
  }

  label {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 6px;

    display: flex;
    align-items: center;

    i {
      color: ${props => props.theme["$gray-5"]};
      font-size: 14px;
      margin-left: 5px;
    }
  }

  input.step-search-input {
    padding: 0.25em 0.5em 0.25em 2em;
    min-width: 256px;
    max-width: 400px;
    background: white;
    border-radius: 6px;
    border: 1px solid ${props => props.theme["$gray-5"]};

    color: ${props => props.theme["$gray-5"]};
    outline: none;
    font-size: 1rem;
    font-weight: 500;
    font-family: ${props => props.theme["$font-body"]};
    line-height: 1.75rem;

    &::placeholder {
      color: ${props => props.theme["$gray-5"]};
      font-style: italic;
    }

    &:focus,
    &:hover {
      border-color: ${props => props.theme["$gray-7"]};
      color: ${props => props.theme["$gray-7"]};

      & + label i {
        color: ${props => props.theme["$gray-7"]};
      }
    }
  }

  .search-container.active input.step-search-input {
    color: ${props => props.theme["$gray-7"]};
    & + label i {
      color: ${props => props.theme["$gray-7"]};
    }
  }
`;
